import { SearchIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { CloseCircleFill } from '~/core/ui/FillIcons'
import { Input } from '~/core/ui/Input'
import { InputRightAddon } from '~/core/ui/InputAddon'

const SearchHeader = ({
  searchTerm,
  onChange,
  onClearInput
}: {
  searchTerm: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClearInput: () => void
}) => {
  const { t } = useTranslation()

  return (
    <div className="flex h-12 items-center border-b border-gray-200 px-4">
      <div className="flex w-full items-center gap-2">
        <SearchIcon size={16} className="h-4 w-4 text-gray-400" />
        <input
          type="text"
          value={searchTerm}
          onChange={onChange}
          placeholder={`${t('label:placeholder:search')}`}
          className="outline-hidden w-full text-sm"
          autoFocus
        />
        {searchTerm ? (
          <div
            className="cursor-pointer"
            onClick={() => {
              onClearInput()
            }}>
            <CloseCircleFill size={16} className={`fill-gray-400 dark:fill-gray-500`} />
          </div>
        ) : undefined}
      </div>
    </div>
  )
}

export default SearchHeader
